import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";
import { getAreaInfoByName } from "../adapter.api";

export class AreaService {
  static async fetchAreaInfoByName({
    areaName,
    mapsMapType,
    isOpendata,
  }: {
    areaName: string;
    mapsMapType?: string;
    isOpendata?: boolean;
  }): Promise<PortalAdapterApi.TopArea> {
    return getAreaInfoByName({ areaName, mapsMapType, isOpendata });
  }
}
